<script setup>
import { ref, computed } from 'vue'
import { store } from '@/store/appStore.js'

const warehouseFilter = ref('All'); const search = ref('')
const stock = store.scmV2.stock
const warehouses = computed(() => ['All', ...store.scmV2.warehouses])
const filtered = computed(() => {
  const q = search.value.trim().toLowerCase()
  return stock.filter(s => (warehouseFilter.value==='All'||s.warehouse===warehouseFilter.value) && (!q||s.productName.toLowerCase().includes(q)||s.productSku.toLowerCase().includes(q)||s.batchNo.toLowerCase().includes(q)))
})
function barSegments(s) {
  const total = s.availableQty + s.reservedQty + s.inTransitQty
  if (!total) return { a:0, r:0, t:0 }
  return { a: Math.round(s.availableQty/total*100), r: Math.round(s.reservedQty/total*100), t: Math.round(s.inTransitQty/total*100) }
}
</script>

<template>
  <div>
    <div class="card module-header"><h2>{{ stock.length }} SKU × warehouse positions</h2></div>
    <div class="card">
      <div class="toolbar" style="flex-wrap:wrap;">
        <div style="display:flex;gap:4px;">
          <button v-for="w in warehouses" :key="w" class="filter-select" :style="warehouseFilter===w?'background:var(--color-primary-dark);color:#fff;border-color:var(--color-primary-dark);':'cursor:pointer;'" @click="warehouseFilter=w">{{ w }}</button>
        </div>
        <input class="search-input" v-model="search" placeholder="Search product, SKU or batch no.…" />
        <span class="result-count">{{ filtered.length }} of {{ stock.length }} shown</span>
      </div>
      <div class="table-wrap">
        <table class="data-table">
          <thead><tr><th>Product</th><th>Warehouse</th><th>Batch No.</th><th>Expiry Date</th><th style="min-width:160px;">Available / Reserved / In-Transit</th></tr></thead>
          <tbody>
            <tr v-for="s in filtered" :key="s.productSku+s.warehouse">
              <td class="cell-strong">{{ s.productName }}</td><td>{{ s.warehouse }}</td>
              <td class="cell-muted">{{ s.batchNo }}</td><td class="cell-muted">{{ s.expiryDate }}</td>
              <td>
                <div style="display:flex;height:14px;border-radius:4px;overflow:hidden;background:var(--color-border);margin-bottom:4px;">
                  <div :style="{width: barSegments(s).a+'%', background: 'var(--status-green)'}" :title="'Available: '+s.availableQty"></div>
                  <div :style="{width: barSegments(s).r+'%', background: 'var(--color-accent)'}" :title="'Reserved: '+s.reservedQty"></div>
                  <div :style="{width: barSegments(s).t+'%', background: 'var(--color-primary-dark)'}" :title="'In-Transit: '+s.inTransitQty"></div>
                </div>
                <span class="cell-muted" style="font-size:11px;">{{ s.availableQty }} / {{ s.reservedQty }} / {{ s.inTransitQty }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
